<form novalidate #propertyFeaturesSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col lg="9" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>Features</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col sm="12">
                    <p>
                        Provide some further details about the features that
                        make the property stand out
                    </p>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Bedrooms"
                    >
                        <select
                            tgSelect
                            name="bedrooms"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.bedrooms"
                            [validation]="
                                validation.propertyInformation.bedrooms
                                    | toValidator: metadata.bedrooms
                            "
                            [disabled]="isDisabledInput"
                        >
                            <option
                                *ngFor="let opt of metadata.bedrooms"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Bathrooms"
                    >
                        <select
                            tgSelect
                            name="bathrooms"
                            (change)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.bathrooms
                            "
                            [validation]="
                                validation.propertyInformation.bathrooms
                                    | toValidator: metadata.bathrooms
                            "
                            [disabled]="isDisabledInput"
                        >
                            <option
                                *ngIf="
                                    draftData.propertyInformation.bathrooms ===
                                    0
                                "
                                [ngValue]="0"
                                selected
                            ></option>
                            <option
                                *ngFor="let opt of metadata.bathrooms"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Separate toilets">
                        <select
                            tgSelect
                            name="toilets"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.toilets"
                            [validation]="
                                validation.propertyInformation.toilets
                                    | toValidator: metadata.toilets
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.toilets"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Ensuite bathrooms">
                        <select
                            tgSelect
                            name="ensuites"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.ensuites"
                            [validation]="
                                validation.propertyInformation.ensuites
                                    | toValidator: metadata.ensuites
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.ensuites"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Living areas / Lounges">
                        <select
                            tgSelect
                            name="lounges"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.lounges"
                            [validation]="
                                validation.propertyInformation.lounges
                                    | toValidator: metadata.lounges
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.lounges"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Studies">
                        <select
                            tgSelect
                            name="studies"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.studies"
                            [validation]="
                                validation.propertyInformation.studies
                                    | toValidator: metadata.studies
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.studies"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="property-features-section__home-and-income-select"
                        label="Home & income potential"
                    >
                        <select
                            tgSelect
                            name="homeAndIncome"
                            (change)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.homeAndIncome
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.homeAndIncome"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                    <p class="property-features-section__home-and-income-text">
                        Does the property have two dwellings on one title that
                        could provide the flexibility of home and income living?
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
        <tg-col></tg-col>
        <property-information-notice-with-display-fields
            displayFields="address, bedrooms, bathrooms and land area"
            *ngIf="isDisabledInput">
        </property-information-notice-with-display-fields>
    </tg-row>
</form>
